import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const CreateProjectGeneralDetailWrapper = styled.div`
  .MuiGrid2-root {
    padding-right: 16px;
  }

  .MuiTabs-flexContainer {
    border-bottom: 5px solid ${COLORS.cirrus_black3};
  }

  .key-detail-tab {
    padding: 0px 16px 24px 16px;
    ${responsive.MOBILE`
      padding: 0 8px 16px 8px;
    `}
    .value-style {
      line-height: 20px;
      color: ${COLORS.cirrus_black};
    }
  }

  .modify-detail {
    padding: 16px 24px 16px 16px;
    border-bottom: 1px solid ${COLORS.cirrus_black3};
    text-align: end;

    ${responsive.MOBILE`
      padding: 16px 16px 16px 8px;
    `}

    .link {
      color: ${COLORS.primary_light_blue};
      svg {
        padding-right: 5px;
        color: ${COLORS.primary_light_blue};
      }
    }
  }
`;
